var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLoyalty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-934 516 50 50",
    style: {
      enableBackground: "new -934 516 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#00DC86;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:#000;}\n\t.st2{fill:#000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-922,536.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-907.6,531.1h-19.9c-3,0-5.5,2.5-5.5,5.5v12c0,3,2.5,5.5,5.5,5.5h19.9c3,0,5.5-2.5,5.5-5.5v-12   C-902.1,533.6-904.6,531.1-907.6,531.1z M-927.5,534.1h19.9c1.4,0,2.5,1.1,2.5,2.5v0.2H-930v-0.2   C-930,535.3-928.9,534.1-927.5,534.1z M-907.6,551.1h-19.9c-1.4,0-2.5-1.1-2.5-2.5v-8.8h24.9v8.8   C-905.1,550-906.2,551.1-907.6,551.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-919.9,545.8h-7c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h7c0.8,0,1.5-0.7,1.5-1.5S-919,545.8-919.9,545.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-898.6,518.3c-3.8,0-7.6,1.6-10.4,4.2c-2.8-2.7-6.6-4.2-10.4-4.2c-7.2,0-13,5.3-14.1,12.3   c1-1,2.2-1.7,3.6-2.1c1.6-4.2,5.6-7.2,10.4-7.2c3.5,0,7,1.6,9.3,4.4c0.6,0.7,1.7,0.7,2.3,0c2.3-2.8,5.8-4.4,9.3-4.4   c6.3,0,11.2,5.1,11.2,11.5c0,6.7-5.1,12.7-13.2,20.5c-1.1,1.1-1.9,1.8-2.8,2.7c-1.1,1-2.2,2-3.3,3.1l-1.3,1.2c-0.6,0.5-1.5,0.5-2,0   l-1.3-1.2c-0.7-0.7-1.4-1.3-2.1-1.9h-4.4c1.4,1.3,2.9,2.7,4.4,4.1l1.3,1.2c0.8,0.8,2,1.2,3.1,1.2c1.1,0,2.2-0.4,3.1-1.2l1.3-1.2   c12.2-11.3,20.3-18.8,20.3-28.4C-884.3,524.7-890.6,518.3-898.6,518.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLoyalty);
export default __webpack_public_path__ + "static/media/brand-loyalty.99c7962ad753065701cd4951f0072b1e.svg";
export { ForwardRef as ReactComponent };